import { Component, Input, OnInit } from '@angular/core';
import { TickerTableDataSource } from '../main-table-content-v2/TickerTableDataSource';
import { AggFieldConfigDO, AggFieldType, FieldConfigDTO } from '../../../../../system/system-dtos';
import { DataTypeAggsService } from '../../../../data-type-widgets/data-type/services/data-type-aggs.service';

@Component({
  selector: 'app-main-table-v2-aggs',
  templateUrl: './main-table-v2-aggs.component.html',
  styleUrls: ['./main-table-v2-aggs.component.scss'],
  standalone: false,
})
export class MainTableV2AggsComponent implements OnInit {
  _dataSource: TickerTableDataSource;

  @Input()
  set dataSource(ds: TickerTableDataSource) {
    this._dataSource = ds;
    if (this._dataSource) {
      this.updateAggsForTickers();
      this._dataSource.pageDataSubject.subscribe((_) => this.updateAggsForTickers());
    }
  }

  constructor(private dataTypeAggsService: DataTypeAggsService) {}

  aggs: Map<string, string>;

  ngOnInit(): void {}

  private updateAggsForTickers() {
    const aggDefMap = new Map<AggFieldType, any>();
    this._dataSource.tableConfig.rows[0].columns[0].fields
      .filter((f) => f.aggs)
      .forEach((f) => {
        f.aggs.forEach((agg: AggFieldConfigDO) => {
          aggDefMap.set(agg.type, f);
        });
      });

    const aggMap = new Map<string, string>();
    aggDefMap.forEach((def: FieldConfigDTO, type) => {
      const data = this._dataSource.filteredData.map((d) => d.data);
      if (data == null || data.length == 0) {
        return;
      }
      aggMap.set(`${type} ${def.label}`, this.dataTypeAggsService.aggregate(type, def, data));
    });

    this.aggs = aggMap;
  }
}
